import script from "./CompanySetup.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanySetup.vue?vue&type=script&setup=true&lang=js"

import "./CompanySetup.vue?vue&type=style&index=0&id=23f07f27&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f07f27"]])

export default __exports__